import { render, staticRenderFns } from "./busInformation.vue?vue&type=template&id=5813e1bf&scoped=true&"
import script from "./busInformation.vue?vue&type=script&lang=js&"
export * from "./busInformation.vue?vue&type=script&lang=js&"
import style0 from "./busInformation.vue?vue&type=style&index=0&id=5813e1bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813e1bf",
  null
  
)

export default component.exports